/**
 * Custom JSX Runtime for @smoothie-framework/ui
 *
 * Integrates with the UINode rendering architecture.
 * Components return UINode descriptors that are rendered by the patch runtime.
 * Lowercase intrinsic tags lower directly to a curated DOM/WebView host-tag
 * allowlist today and should be treated as an explicit host escape hatch rather
 * than the portable cross-runtime contract.
 *
 * @module @smoothie-framework/ui/jsx-runtime
 */
import { createNodeId } from './render/node-id';
import { ensureNodeId, normalizeChildNodes } from './render/child-nodes';
import { createRuntimeComponentNode, createRuntimeComponentRender, } from './render/runtime-component';
export function jsx(type, props, key) {
    const { children, ...restProps } = props;
    if (typeof type === 'function') {
        const componentType = type;
        const ownerName = type.displayName
            ?? type.name
            ?? 'AnonymousComponent';
        return createRuntimeComponentNode({
            id: createNodeId(),
            key,
            ownerName,
            component: componentType,
            render: createRuntimeComponentRender({
                ownerName,
                render: () => componentType({
                    ...restProps,
                    children,
                }),
                normalize: (result) => Array.isArray(result)
                    ? {
                        id: createNodeId(),
                        type: 'Fragment',
                        props: restProps,
                        children: normalizeChildNodes(result),
                        key,
                    }
                    : ensureNodeId(result),
            }),
        });
    }
    const childNodes = normalizeChildNodes(children);
    return {
        id: createNodeId(),
        type,
        props: restProps,
        children: childNodes,
        key,
    };
}
export function jsxs(type, props, key) {
    return jsx(type, props, key);
}
export function jsxDEV(type, props, key, _isStaticChildren, _source, _self) {
    return jsx(type, props, key);
}
export function Fragment(props) {
    return {
        id: createNodeId(),
        type: 'Fragment',
        props: {},
        children: normalizeChildNodes(props.children),
        key: props.key,
    };
}
export { jsx as createElement };
//# sourceMappingURL=jsx-runtime.js.map